export const tr = {
    'asc-order': 'Önce eski',
    'desc-order': 'Önce yeni',
    'order-by-date-label': 'Tarihe göre sırala'
};
